import { useStyles } from './title-block.style'
import { PlainTextBlock } from '../plaintext/plaintext-block'

export const TitleBlock = function ({ report = {} }) {
  const classes = useStyles()

  return <PlainTextBlock className={classes.title} as="h1" name="title" report={report} placeholder="Page title is required" />
}
